import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { QuestionMarkSVG } from '@common_components/svg/questionMark.svg';

const QuestionMarkIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <QuestionMarkSVG/>
    </div>
  );
};

export { QuestionMarkIcon };